import { css, keyframes } from 'styled-components';

export const spin = keyframes`
  100% { transform: rotate(360deg); }
`;

const placeHolderShimmer = keyframes`
  0% { background-position: 0% 100%; }

  50% { background-position: 100% 50%; }

  100% { background-position: 0% 50%; }
`;

export const loadingAnimation = (primary = '#eee', secondary = '#ccc') => css`
  background: linear-gradient(
    270deg,
    ${primary},
    ${secondary},
    ${primary},
    ${secondary}
  );
  background-size: 800% 800%;
  animation: 4s ease infinite;
  animation-name: ${placeHolderShimmer};
`;
